var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('van-sticky',[(!_vm.getOpenInWechat)?_c('navbar'):_vm._e()],1),_c('router-view',{attrs:{"id":"layout"}}),(_vm.getTabbarItem.isShow && _vm.isShow)?_c('tabbar'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }